/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ResumeStripeSubscriptionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ResumeStripeSubscriptionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ResumeStripeSubscriptionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ResumeStripeSubscriptionSecurity$outboundSchema: z.ZodMiniType<
  ResumeStripeSubscriptionSecurity$Outbound,
  ResumeStripeSubscriptionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function resumeStripeSubscriptionSecurityToJSON(
  resumeStripeSubscriptionSecurity: ResumeStripeSubscriptionSecurity,
): string {
  return JSON.stringify(
    ResumeStripeSubscriptionSecurity$outboundSchema.parse(
      resumeStripeSubscriptionSecurity,
    ),
  );
}

/** @internal */
export type ResumeStripeSubscriptionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ResumeStripeSubscriptionRequest$outboundSchema: z.ZodMiniType<
  ResumeStripeSubscriptionRequest$Outbound,
  ResumeStripeSubscriptionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function resumeStripeSubscriptionRequestToJSON(
  resumeStripeSubscriptionRequest: ResumeStripeSubscriptionRequest,
): string {
  return JSON.stringify(
    ResumeStripeSubscriptionRequest$outboundSchema.parse(
      resumeStripeSubscriptionRequest,
    ),
  );
}
